// French rendering of the report/action sentence templates produced by the
// scrubbing libraries (marker names stay in their original form).
const FR_RULES = [
  [/^pixel-domain disruption \(light\): /, "perturbation pixel (légère) : "],
  [/^pixel-domain disruption \(balanced\): /, "perturbation pixel (équilibrée) : "],
  [/^pixel-domain disruption \(strong\): /, "perturbation pixel (forte) : "],
  [/^pixel-domain disruption \(maximum\): /, "perturbation pixel (maximum) : "],
  [/^pixel-domain disruption \(extreme\): /, "perturbation pixel (extrême) : "],
  [/^info: visible wording kept in the content: /, "info : mots visibles conservés dans le contenu : "],
  [/^byte-scan markers: /, "marqueurs repérés (octets) : "],
  [/^byte-scan C2PA markers: /, "marqueurs C2PA repérés (octets) : "],
  [/^PNG chunk (\S+) \(possible C2PA container\)$/, "chunk PNG $1 (conteneur C2PA possible)"],
  [/^PNG (\w+) metadata chunk \((\d+) bytes\)$/, "chunk de métadonnées PNG $1 ($2 octets)"],
  [/^PNG (\w+): /, "PNG $1 : "],
  [/^JPEG APP11 segment \(JUMBF\/C2PA common\)$/, "segment JPEG APP11 (JUMBF/C2PA)"],
  [/^JPEG (APP\d+) metadata segment \((\d+) bytes\)$/, "segment de métadonnées JPEG $1 ($2 octets)"],
  [/^JPEG (APP\d+): /, "JPEG $1 : "],
  [/^truncated chunk /, "chunk tronqué "],
  [/^drop chunk /, "suppression du chunk "],
  [/ \(C2PA marker in payload\)$/, " (marqueur C2PA dans les données)"],
  [/^drop APP(\d+) \(C2PA\/JUMBF\)$/, "suppression d'APP$1 (C2PA/JUMBF)"],
  [/^drop APP(\d+) \(AI\/C2PA markers\)$/, "suppression d'APP$1 (marqueurs IA/C2PA)"],
  [/^drop APP(\d+)$/, "suppression d'APP$1"],
  [/^drop APP11 \(C2PA\/JUMBF\)$/, "suppression d'APP11 (C2PA/JUMBF)"],
  [/^drop COM comment$/, "suppression du commentaire COM"],
  [/^no PNG metadata chunks removed \(already clean\)$/, "aucun chunk de métadonnées PNG retiré (déjà propre)"],
  [/^no JPEG APP segments removed$/, "aucun segment APP JPEG retiré"],
  [/^preserved entropy-coded scan \(SOS to EOF\)$/, "données d'image préservées (SOS → fin de fichier)"],
  [/^copied remainder after non-marker byte$/, "reste du fichier copié tel quel"],
  [/^truncated segment; copied remainder$/, "segment tronqué ; reste copié"],
  [/^XMP metadata packet present$/, "paquet de métadonnées XMP présent"],
  [/^blank XMP metadata packet$/, "paquet XMP neutralisé"],
  [/^blank <x:xmpmeta> block$/, "bloc <x:xmpmeta> neutralisé"],
  [/^blank (\/\w+) value$/, "valeur $1 neutralisée"],
  [/^no uncompressed PDF metadata found \(already clean or compressed\)$/, "aucune métadonnée PDF non compressée trouvée (déjà propre ou compressée)"],
  [/^<metadata> block present$/, "bloc <metadata> présent"],
  [/^drop <metadata> block$/, "suppression du bloc <metadata>"],
  [/^drop <xmpmeta> block$/, "suppression du bloc <xmpmeta>"],
  [/^drop <rdf:RDF> block$/, "suppression du bloc <rdf:RDF>"],
  [/^drop <desc> block$/, "suppression du bloc <desc>"],
  [/^drop xpacket marker$/, "suppression du marqueur xpacket"],
  [/^drop AI-related comment$/, "suppression d'un commentaire lié à l'IA"],
  [/^drop JSON-LD provenance block$/, "suppression du bloc JSON-LD de provenance"],
  [/^drop data-ai\* attributes$/, "suppression des attributs data-ai*"],
  [/^drop meta tag: /, "suppression de la balise meta : "],
  [/^meta tag: /, "balise meta : "],
  [/^frontmatter AI key: /, "clé IA dans le frontmatter : "],
  [/^drop frontmatter key: /, "suppression de la clé frontmatter : "],
  [/^Layer A: (\d+) invisible chars removed$/, "couche A : $1 caractères invisibles retirés"],
  [/^(\d+) invisible\/format Unicode chars \(Layer A\)$/, "$1 caractères Unicode invisibles ou de format (couche A)"],
  [/^no invisible Unicode found$/, "aucun caractère Unicode invisible trouvé"],
  [/^Layer A scrub in (.+) \((\d+)\)$/, "nettoyage couche A dans $1 ($2)"],
  [/^clear document properties in /, "propriétés du document effacées dans "],
  [/^document part: /, "partie de document : "],
  [/^no document properties found \(already clean\)$/, "aucune propriété de document trouvée (déjà propre)"],
  [/^meta\.xml present \(generator \/ creator metadata\)$/, "meta.xml présent (métadonnées generator / creator)"],
  [/^scrub meta\.xml generator\/creator$/, "nettoyage de generator/creator dans meta.xml"],
  [/^drop /, "suppression de "],
  [/^inspection error: /, "erreur d'inspection : "],
  [/^unsupported format$/, "format non pris en charge"],
  [/^not a (PNG|JPEG)$/, "ce n'est pas un $1"],
];

export function localizeReport(line, lang) {
  if (lang !== "fr") return line;
  let out = line;
  for (const [re, rep] of FR_RULES) {
    if (re.test(out)) { out = out.replace(re, rep); break; }
  }
  return out
    .replace(/\bcrop ([\d.]+)%/, (m, v) => `recadrage ${v.replace(".", ",")} %`)
    .replace(/\brotate ([\d.]+)°/, (m, v) => `rotation ${v.replace(".", ",")}°`)
    .replace(/resample ×([\d.]+)/g, (m, v) => `ré-échantillonnage ×${v.replace(".", ",")}`)
    .replace(/noise-layer resynthesis \(keep ([\d.]+)\)/, (m, v) => `resynthèse de la couche de bruit (conservation ${v.replace(".", ",")})`)
    .replace(/±(\d+) dither/, "tramage ±$1")
    .replace(/gamma ([\d.]+)/, (m, v) => `gamma ${v.replace(".", ",")}`)
    .replace(/(\d+) re-encode pass\(es\)/, "$1 passe(s) de ré-encodage");
}
